<app-notification-header
  [text]="'notifications.offline.title' | translate"
></app-notification-header>

<div class="notification-expanded-content">
  <app-notification-content
    [icon]="SvgIcon.TOWER_CELL"
    [text]="'notifications.offline.text' | translate"
    [buttonText]="'notifications.offline.buttonText' | translate"
    (buttonClicked)="slideUp()"
  ></app-notification-content>
</div>
